module.exports = __webpack_public_path__ + "img/1GOLDAPPLE.0ffe4988.png";